import { Sizes } from '@actr/style';
import { FlexDirection, FlexWrapper } from '@actr/ui/src/components/_atoms/flex-wrapper';
import { Text } from '@actr/ui/src/components/_atoms/text';
import { formatMoney } from '@actr/utilities/src/currency';
import { DecodeImageQuality, getDecodeImage } from '@actr/utilities/src/url/decode-image';
import React, { FC } from 'react';

import * as Styled from './style.css';

export type DestinationCardProps = {
  /** Название направления/города/страны */
  name: string;
  /** URL изображения для карточки */
  image: string;
  /** Ссылка для перехода при клике */
  route?: string;
  /** Индекс элемента в списке (используется для Schema.org position) */
  imageIndex: number;
  /** Дополнительные CSS классы */
  className?: string;
  /** Включить микроразметку Schema.org */
  showSchema?: boolean;
  /** Фиксированная ширина изображения для мобильных */
  fixedImgWidth?: string;
  /** Минимальная стоимость предложения */
  minPrice: number | null;
};

const DestinationCard: FC<DestinationCardProps> = ({
  name,
  image,
  route,
  imageIndex,
  className,
  showSchema = false,
  fixedImgWidth,
  minPrice
}) => {
  const imageSrc = getDecodeImage(image, DecodeImageQuality.Q30);

  const cardContent = (
    <a
      itemProp={showSchema ? 'url' : undefined}
      className={`${Styled.City} ${className || ''}`}
      href={route}>
      <img
        className={Styled.CityImg({ fixedImgWidth: !!fixedImgWidth })}
        style={fixedImgWidth ? { '--city-img-mobile-width': fixedImgWidth } as React.CSSProperties : undefined}
        src={imageSrc}
        alt={name}
        itemProp={showSchema ? 'image' : undefined}
      />
      <FlexWrapper gap={Sizes.X4S} direction={FlexDirection.COL} className={Styled.Content}>
        <Text font="title.m" tagProps={{ itemProp: showSchema ? 'name' : undefined }}>
          {name.replace(/ - /g, ' → ')}
        </Text>
        {!!minPrice && (
          <Text font="title.m" className={Styled.Price}>
            от
            {' '}
            {formatMoney(minPrice)}
          </Text>
        )}
      </FlexWrapper>
    </a>
  );

  if (showSchema) {
    return (
      <div itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
        <meta itemProp="position" content={(imageIndex + 1).toString()} />
        <div itemProp="item" itemScope itemType="https://schema.org/TouristDestination">
          {cardContent}
          {/* TODO Завести задачу на получение региона */}
          {/* <meta itemProp="address" content="" /> */}
        </div>
      </div>
    );
  }

  return cardContent;
};

export default DestinationCard;
